module.exports = __webpack_public_path__ + "img/ChargeBee.360a4fba.png";